<script lang="ts">
	import { env } from '$env/dynamic/public';
	import { Image, OutboundLink } from '@cf/ui-lib';

	export let url;
	export let id;
</script>

<div class="flex -space-x-3 rtl:space-x-reverse">
	<div class=" group relative h-12 w-[69px] cursor-pointer rounded-md border-4 border-white">
		<OutboundLink href={`/uilib/brands/brands-details/edit/${id}`}>
			<Image class="h-full w-full rounded-md object-cover" src={url} alt="" />
		</OutboundLink>
	</div>
</div>
